/**
 * Front-End Gift Card & Note Management Module
 */
(function() {
  document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById("GiftCardModal");
    if (!modal) return;

    const charCounter = document.getElementById("GiftNoteCharCount");
    const textArea = document.getElementById("GiftModalNote");
    const submitBtn = document.getElementById("SubmitGiftAndCheckout");
    const declineBtn = document.getElementById("DeclineGiftCard");
    
    let activeTrigger = null;
    let isCheckoutFlow = false;

    // Grab the configured gift card IDs from the modal
    const giftVariantIds = modal.getAttribute("data-gift-variant-ids").split(",").filter(Boolean);

    // Listen to the theme's native AJAX cart updates
    document.addEventListener("cart:updated", (evt) => {
      const cart = evt.detail.cart;
      if (!cart || !cart.items) return;
      
      const hasGift = cart.items.some(item => giftVariantIds.includes(String(item.variant_id)));
      modal.setAttribute("data-has-gift-in-cart", hasGift ? "true" : "false");
      
      if (hasGift) document.body.classList.add("has-gift-card");
      else document.body.classList.remove("has-gift-card");
    });

    // Synchronise characters count field and evaluate validity dynamically
    textArea.addEventListener("input", (e) => {
      if (charCounter) {
        charCounter.textContent = e.target.value.length;
      }
      checkValidityState();
    });

    const preventFocusSteal = (e) => {
      if (modal.contains(e.target)) e.stopImmediatePropagation();
    };

    // Ensure the first gift card option is selected by default
    const ensureDefaultSelection = () => {
      const selectedRadio = modal.querySelector('input[name="gift_card_selection"]:checked');
      if (!selectedRadio) {
        const firstRadio = modal.querySelector('input[name="gift_card_selection"]');
        if (firstRadio) {
          firstRadio.checked = true;
        }
      }
    };

    // Evaluate validity: both a design selection AND a non-empty gift note are required
    const checkValidityState = () => {
      const selectedRadio = modal.querySelector('input[name="gift_card_selection"]:checked');
      const hasNote = Boolean(textArea && textArea.value.trim().length > 0);

      if (selectedRadio && hasNote) {
        submitBtn.removeAttribute("disabled");
      } else {
        submitBtn.setAttribute("disabled", "true");
      }
    };

    ensureDefaultSelection();
    checkValidityState();

    // ==========================================
    // CUSTOM SMOOTH SCROLL HELPER
    // ==========================================
    const smoothScrollTo = (container, targetPosition, duration) => {
      const startPosition = container.scrollTop;
      const distance = targetPosition - startPosition;
      let startTime = null;

      const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        // Cap progress at 1 (100%)
        const progress = Math.min(timeElapsed / duration, 1);
        
        // Easing function (easeInOutQuad) for a natural, elegant feel
        const ease = progress < 0.5 
          ? 2 * progress * progress 
          : -1 + (4 - 2 * progress) * progress;

        container.scrollTop = startPosition + (distance * ease);

        // Continue animating until duration is reached
        if (timeElapsed < duration) {
          window.requestAnimationFrame(animation);
        }
      };

      window.requestAnimationFrame(animation);
    };
    
    // Focus and scroll down to the note textarea when a card design is chosen
    modal.addEventListener("change", (e) => {
      if (e.target.name === "gift_card_selection") {
        checkValidityState();

        const noteArea = modal.querySelector(".gift-modal__note-input-area");
        if (noteArea) {
          setTimeout(() => {
            const modalContainer = modal.querySelector(".gift-modal__container");
            const targetScroll = noteArea.offsetTop - 24;
            smoothScrollTo(modalContainer, targetScroll, 600);

            setTimeout(() => {
              if (textArea) textArea.focus();
            }, 600);
          }, 50);
        }
      }
    });

    // Universal Open Action Modal Logic
    const openModal = (triggerElement, isCheckout) => {
      activeTrigger = triggerElement;
      isCheckoutFlow = isCheckout;
      
      modal.setAttribute("aria-hidden", "false");
      modal.classList.add("is-active");
      
      document.body.style.overflow = "hidden";
      window.addEventListener("focusin", preventFocusSteal, true);
      document.addEventListener("keydown", handleEscapeKey);
      
      // Ensure the first gift card option is selected by default and check validity
      ensureDefaultSelection();
      checkValidityState();

      // Focus the text area so the user can immediately type
      setTimeout(() => {
        if (textArea) textArea.focus();
      }, 50);
    };

    // Close Action Modal Logic
    const closeModal = () => {
      modal.setAttribute("aria-hidden", "true");
      modal.classList.remove("is-active");
      
      document.body.style.overflow = "";
      window.removeEventListener("focusin", preventFocusSteal, true);
      document.removeEventListener("keydown", handleEscapeKey);
      
      if (activeTrigger) activeTrigger.focus();
    };

    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        closeModal();
        if (isCheckoutFlow) window.location.href = "/checkout";
      }
    };

    // "No Thank You" Button Handler
    declineBtn.addEventListener("click", (e) => {
      e.preventDefault();
      closeModal();
      if (isCheckoutFlow) window.location.href = "/checkout";
    });

    // Delegation tracking listener for opening or closing interactions
    document.body.addEventListener("click", (e) => {
      const ctaTrigger = e.target.closest("[data-trigger-gift-modal]");
      if (ctaTrigger) {
        e.preventDefault();
        openModal(ctaTrigger, false); 
      }
      if (e.target.closest("[data-close-gift-modal]")) {
        e.preventDefault();
        closeModal();
      }
    });

    // Intercept native checkout button submission bindings securely
    document.body.addEventListener("click", (e) => {
      const checkoutBtn = e.target.closest("[data-buy-now-button], [name='checkout']");
      if (checkoutBtn) {
        const nativeForm = checkoutBtn.closest("form");
        if (nativeForm) {
          const hasGiftInCart = modal.getAttribute("data-has-gift-in-cart") === "true";
          if (!hasGiftInCart) {
            e.preventDefault();
            e.stopPropagation();
            openModal(checkoutBtn, true); 
          }
        }
      }
    });

    // Catch forms that try to submit directly
    document.body.addEventListener("submit", (e) => {
      const action = e.target.getAttribute("action");
      if (action && action.includes("/cart") && e.submitter && e.submitter.getAttribute("name") === "checkout") {
        const hasGiftInCart = modal.getAttribute("data-has-gift-in-cart") === "true";
        if (!hasGiftInCart) {
          e.preventDefault();
          e.stopPropagation();
          openModal(e.submitter, true); 
        }
      }
    });

    // Submit user selection via AJAX natively
    submitBtn.addEventListener("click", (e) => {
      e.preventDefault();

      const selectedRadio = modal.querySelector('input[name="gift_card_selection"]:checked');
      const noteValue = textArea ? textArea.value.trim() : "";

      if (!selectedRadio) {
        return;
      }

      if (!noteValue) {
        if (textArea) {
          textArea.focus();
          if (typeof textArea.reportValidity === "function") {
            textArea.reportValidity();
          }
        }
        return;
      }

      submitBtn.setAttribute("disabled", "true");
      submitBtn.classList.add("loading");

      const variantId = selectedRadio.value;
      const postData = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: { "Gift Note": noteValue }
        }]
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(postData)
      })
      .then(res => res.json())
      .then(data => {
        // Sync the Spark theme's memory bank natively (newest item at the front)
        try {
          const order = JSON.parse(localStorage.getItem('neon_cart_order')) || [];
          const newOrder = [parseInt(variantId), ...order.filter(i => String(i) !== String(variantId))];
          localStorage.setItem('neon_cart_order', JSON.stringify(newOrder));
        } catch(e) {}

        if (isCheckoutFlow) {
          window.location.href = "/checkout";
        } else {
          // Trigger the theme's native cart update seamlessly
          document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
          
          const cartIcon = document.querySelector('[data-js-cart-icon]');
          if (cartIcon) cartIcon.click();
          
          closeModal();
          submitBtn.classList.remove("loading");
        }
      })
      .catch(error => {
        console.error("AJAX Error:", error);
        if (isCheckoutFlow) window.location.href = "/checkout";
        else {
          closeModal();
          submitBtn.classList.remove("loading");
        }
      });
    });

    // ==========================================
    // BULLETPROOF CUSTOM REMOVE FUNCTION
    // ==========================================
    document.body.addEventListener('click', (e) => {
      const customRemoveBtn = e.target.closest('[data-custom-remove]');
      
      if (customRemoveBtn) {
        e.preventDefault();
        e.stopPropagation(); 
        
        const itemKey = customRemoveBtn.getAttribute('data-custom-remove');
        customRemoveBtn.style.opacity = '0.5'; 
        customRemoveBtn.style.pointerEvents = 'none';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        })
        .then(response => response.json())
        .then(cart => {
          try {
            const order = JSON.parse(localStorage.getItem('neon_cart_order')) || [];
            const cartVariantIds = cart.items.map(item => item.variant_id);
            const newOrder = order.filter(id => cartVariantIds.includes(id));
            localStorage.setItem('neon_cart_order', JSON.stringify(newOrder));
          } catch(err) {}

          window.location.href = '/cart';
        })
        .catch(error => {
          console.error("AJAX Remove Error:", error);
          window.location.href = '/cart';
        });
      }
    });
  });
})();